module.exports = __webpack_public_path__ + "img/24.b4588b07.jpg";